module.exports = __webpack_public_path__ + "img/ydy3@3x.3ec13ede.png";